import * as React from 'react';

import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from 'uitk-react-menu';

interface WizardMenuProps {
  children: React.ReactElement | React.ReactElement[];
  label: string;
  labelIcon: string;
  isOpen: boolean;
  toggleMenu: () => void;
  onCloseCallback?: () => void;
  maxHeight?: number;
  dataTestId?: string;
  containerWidth?: number;
}

export const WizardMenu = ({
  label,
  labelIcon,
  maxHeight,
  children,
  isOpen,
  toggleMenu,
  onCloseCallback,
  dataTestId,
  containerWidth
}: WizardMenuProps) => (
  <UitkMenu isOpen={isOpen} onTriggerClick={toggleMenu} onDismiss={onCloseCallback}>
    <UitkMenuTrigger>
      <UitkLink inline={true} iconPos={UitkLinkAlign.RIGHT} data-test-id={dataTestId}>
        <UitkTertiaryButton>
          <UitkLayoutFlex className="uitk-type-300">
            <UitkLayoutFlexItem>
              <>{label}</>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <UitkIcon name={labelIcon} />
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkTertiaryButton>
      </UitkLink>
    </UitkMenuTrigger>
    {children && (
      <UitkMenuContainer position={PositionType.LEFT} maxHeight={maxHeight} width={containerWidth}>
        {React.Children.map(children, child => React.cloneElement(child, { closeMenu: toggleMenu }))}
      </UitkMenuContainer>
    )}
  </UitkMenu>
);
